import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

type CodeName = { id: number; code?: string | null; name?: string | null };

export interface PmsSubComponent {
  id: number;
  componentId: number;
  criticalityId: number;
  recordStatusId: number;
  parentSubComponentId?: number | null;
  code: string;
  name: string;
  description?: string | null;
  isActive?: boolean;
  component?: CodeName | null;
  criticality?: CodeName | null;
  recordStatus?: CodeName | null;
  parentSubComponent?: CodeName | null;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: unknown;
}

export const usePmsSubComponents = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<
    PaginatedApiResponse<PmsSubComponent> | PmsSubComponent[]
  >(`${moduleConfig.module.api.list}${q}`, fetcher, { revalidateOnFocus: true });
  const normalized = normalizePaginatedListResponse<PmsSubComponent>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePmsSubComponent = (id?: number) => {
  const { data, error, isLoading, mutate } = useSWR<PmsSubComponent>(
    id != null && Number.isFinite(id) && id > 0 ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
